import store from '@/store';
import { DASHBOARD_ROUTE, LOGIN_ROUTE, SIGNUP_ROUTE, FORGOT_PASSWORD_ROUTE, RESET_PASSWORD_ROUTE, PROVACY_POLICY_ROUTE, PUBLIC_JOB_APPLICATION_ROUTE } from '@/router/routes';
import { SYNC_ACCOUNT_ORGANIZATION, UPDATE_ERRORMSG } from '@/store/action_types';
import { isModuleEnabled, moduleForRoute, platformModuleMeta } from '@/utils/modules';
import { RouteLocationNormalized } from 'vue-router';

const PUBLIC_ROUTES = new Set<unknown>([
  LOGIN_ROUTE,
  SIGNUP_ROUTE,
  FORGOT_PASSWORD_ROUTE,
  RESET_PASSWORD_ROUTE,
  PROVACY_POLICY_ROUTE,
  PUBLIC_JOB_APPLICATION_ROUTE,
]);

const signedIn = (): boolean => store.getters.sessionToken != null && store.getters.account.data != null;

/**
 * Global guard: a page that belongs to a module the organization is not licensed
 * for redirects to the dashboard. Runs before the per-route auth guards, so a
 * visitor without a session is left to those guards.
 */
export const ifModuleDisabledDeny = (to: RouteLocationNormalized) => {
  const required = moduleForRoute(to.name);
  if (!required || !signedIn()) return true;

  if (isModuleEnabled(store.getters.account.data?.organization, required)) return true;

  store.dispatch(UPDATE_ERRORMSG, {
    errorMsg: `${platformModuleMeta(required).label} is not enabled for your organization.`,
  });
  return { name: DASHBOARD_ROUTE };
};

/**
 * After each navigation, refresh the organization in the background (throttled in
 * the store) so a licence change made by the platform admin shows up without a
 * new sign in.
 */
export const syncOrganizationModules = (to: RouteLocationNormalized) => {
  if (PUBLIC_ROUTES.has(to.name) || !signedIn()) return;
  store.dispatch(SYNC_ACCOUNT_ORGANIZATION);
};
